import {Vue, Component, Watch, Prop} from "vue-property-decorator";
import DfBrand from "@/vue/domain/brand/df-brand";
import Store from "@/vue/infrastructure/store/store";
import DfStore from "@/vue/domain/store/df-store";
import DfContent from "@/vue/domain/content/df-content";

@Component
export default class DfErrorCardComponent extends Vue {
  @Prop({ type: String, default: null })
  errorTitle!: string;
  @Prop({ type: String, default: null })
  errorDescription!: string;
  @Prop({ type: String, default: null })
  errorDescription2!: string;
  @Prop({ type: String, default: null })
  buttonLabel!: string;

  private clickButton() {
    this.$emit("click")
  }
}
